import {
  RETRIEVE_OUTBOUND_HANDLER_FAILURE,
  RETRIEVE_OUTBOUND_HANDLER_REQUEST,
  RETRIEVE_OUTBOUND_HANDLER_SUCCESS,
  HANDLER_CHECKED,
  SELECT_ALL_HANDLERS,
  DESELECT_ALL_HANDLERS,
} from './types/HandlerActionTypes';

export function retrieveOutboundHandlersRequestActionCreator(payload, checkedHandlers) {
  return {
    type: RETRIEVE_OUTBOUND_HANDLER_REQUEST,
    payload,
    checkedHandlers,
  };
}

export function retrieveOutboundHandlersSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_HANDLER_SUCCESS,
    payload,
  };
}

export function retrieveOutboundHandlersFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_HANDLER_FAILURE,
    error,
  };
}

export function handlerCheckedActionCreator(checkedHandlers) {
  return {
    type: HANDLER_CHECKED,
    checkedHandlers,
  };
}

export function onSelectAllHandlers(nodes) {
  return {
    type: SELECT_ALL_HANDLERS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllHandlers() {
  return {
    type: DESELECT_ALL_HANDLERS,
  };
}
